import BaseResource from './index'
import ImageResource from './image'

export default class CalendarTypeResource extends BaseResource {
    static endpoint = '/caltypes'
    static cacheMaxAge = 3600
    static related() {
        return {
            image: ImageResource
        }
    }

    toString() {
        return this.get('name')
    }
}
